import { c as _c } from "react/compiler-runtime";
import { useMutation } from '@tanstack/react-query';
import services from '@/services';
export const useResendEmailMutation = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      mutationFn: _temp
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useMutation(t0);
};
async function _temp(t0) {
  const {
    entryId
  } = t0;
  await services.survey.resendEmail(entryId);
}